import { createConfiguration, DefaultApi, ServerConfiguration } from 'egnahem-api';

const config = createConfiguration({
  baseServer: new ServerConfiguration("http://localhost:8080", {})
});

export const egnahemApi = new DefaultApi(config)
